import { useAxiosPrivate } from "./axios";

const fileDownload = require("js-file-download");

const LIST_QUERY = "/serviceworksheet/list";
const DETAIL_QUERY = "/serviceworksheet/get";
const CREATE_NEW_QUERY = "/serviceworksheet/create";
const UPDATE_QUERY = "/serviceworksheet/update";
const UPDATE_WORKERS_QUERY = "/serviceworksheet/updateworkers";
const RELOAD_SALES_ORDER_QUERY = "/serviceworksheet/refreshsalesorder";
const DELETE_QUERY = "/serviceworksheet/delete";
const DOWNLOAD_PDF = "/serviceworksheet/downloadpdf";
const CLOSE_SW = "/serviceworksheet/close";

export const useSearchServiceWorksheet = () => {
  const searchServiceWorksheet = async (params, callback) => {
    const getUrlSearchParams = (params) => {
      const searchParam = {
        offset: params.offset,
        limit: params.limit,
      };
      if (params.salesOrderNumber !== null) {
        searchParam.salesOrderNumber = params.salesOrderNumber;
      }
      if (params.templateId !== null) {
        searchParam.templateId = params.templateId;
      }
      if (params.userIds !== null) {
        searchParam.userId = params.userIds;
      }
      if (params.date !== null) {
        searchParam.date = params.date;
      }
      if (params.status !== null) {
        searchParam.status = params.status;
      }
      return searchParam;
    };

    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(LIST_QUERY, {
        params: getUrlSearchParams(params),
        paramsSerializer: {
          indexes: null,
        },
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return searchServiceWorksheet;
};

export const useLoadServiceWorksheetById = () => {
  const loadServiceWorksheetById = async (id, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(DETAIL_QUERY, {
        params: {
          id: id,
        },
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return loadServiceWorksheetById;
};

export const useCreateServiceWorksheet = () => {
  const createServiceWorksheet = async (number, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.post(
        CREATE_NEW_QUERY,
        { number: number },
        {
          signal: controller.signal,
        },
      );
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return createServiceWorksheet;
};

export const useUpdateServiceWorksheet = () => {
  const updateServiceWorksheet = async (serviceWorksheet, callback) => {
    try {
      const controller = new AbortController();
      const templateVersionIds = serviceWorksheet?.templates.map((template) => {
        return {
          name: template.name,
          versionId: template.template.version_id,
        };
      });

      const param = {
        id: serviceWorksheet.id,
        note: serviceWorksheet.note,
        templateVersionIds: templateVersionIds,
        primaryWorkerId: serviceWorksheet?.primaryWorker?.id,
        workersId: serviceWorksheet?.workers.map((worker) => worker.id),
        date: {
          type: serviceWorksheet?.date?.type,
          date1: serviceWorksheet?.date?.date1Time,
          date2: serviceWorksheet?.date?.date2Time,
        },
      };
      const response = await axiosPrivate.put(UPDATE_QUERY, param, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return updateServiceWorksheet;
};

export const useUpdateWorkersChange = () => {
  const updateWorkersChange = async (serviceWorksheet, callback) => {
    try {
      const controller = new AbortController();
      const param = {
        id: serviceWorksheet.id,
        primaryWorkerId: serviceWorksheet?.primaryWorker?.id,
        workersId: serviceWorksheet?.workers.map((worker) => worker.id),
      };
      const response = await axiosPrivate.put(UPDATE_WORKERS_QUERY, param, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return updateWorkersChange;
};

export const useReloadSalesOrder = () => {
  const reloadSalesOrder = async (id, callback) => {
    try {
      const controller = new AbortController();
      const param = {
        id: id,
      };
      await axiosPrivate.put(RELOAD_SALES_ORDER_QUERY, param, {
        signal: controller.signal,
      });
      callback();
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return reloadSalesOrder;
};

export const useDeleteServiceWorksheetById = () => {
  const deleteServiceWorksheetById = async (serviceWorksheetId, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.delete(DELETE_QUERY, {
        data: serviceWorksheetId,
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return deleteServiceWorksheetById;
};

export const useDownloadPdf = () => {
  const downloadPdf = async (id, name, shortVersion, callback) => {
    const searchParam = {
      id: id,
      shortVersion: shortVersion,
    };
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(DOWNLOAD_PDF, {
        params: searchParam,
        signal: controller.signal,
        responseType: "blob",
      });
      fileDownload(response.data, name);
      callback(true);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return downloadPdf;
};

export const useCloseServiceWorksheet = () => {
  const closeServiceWorksheet = async (id, callback) => {
    try {
      const controller = new AbortController();
      const param = {
        id: id,
      };
      await axiosPrivate.put(CLOSE_SW, param, {
        signal: controller.signal,
      });
      callback(true);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return closeServiceWorksheet;
};
